<template>
    <div class="site-faq">
        <heading title="FAQ" tag="site-faq-title"/>
    </div>
</template>

<script>
import Vue from 'vue'

export default Vue.extend({
    name: 'SiteFAQ',
    data () {
        return {}
    },
    methods: {}
})
</script>
